<div class="tabs tabBlue">
  <span id="allStoriesLabelHomePage" class="tablinks all_stories"  (click)="showAllStory = true;showMyWorkSpace = false;showMyDashboard = false;showNotificationList = false" 
  [class]="showAllStory ? 'active' : ' '" id="defaultOpen">All Stories</span>
  <span class="tablinks my_workspace" (click)="showAllStory = false;showMyWorkSpace = true;showMy = true;showMyDashboard = false;showNotificationList = false" [class]="showMyWorkSpace ? 'active' : ' '" >My Workspace</span>
  <span class="tablinks my_workspace" (click)="showAllStory = false;showMyWorkSpace = false;showNotificationList = true;showMyDashboard = false" [class]="showNotificationList ? 'active' : ' '" >Notification List</span>
  <span *ngIf="showMyDashboardTab" class="tablinks my_workspace" (click)="showAllStory = false;showMyWorkSpace = false;showMyDashboard = true;showNotificationList = false" [class]="showMyDashboard ? 'active' : ' '" >My Dashboard</span>
</div> 
<div class="pageContainer tabcontent" id="allStories" 
[style.display] = "showAllStory ? 'block' : 'none'" style="display: block;">
      <app-all-story-listing></app-all-story-listing>
</div>
<div class="pageContainer tabcontent" id="myWorkspace" 
[style.display] = "showMyWorkSpace ? 'block' : 'none'"  *ngIf="showMy">
      <app-all-story-listing [byAuthor]="author_name"></app-all-story-listing>
</div>
<div class="pageContainer tabcontent" id="myDashboard" 
[style.display] = "showMyDashboard ? 'block' : 'none'"  *ngIf="showMyDashboard">
     <app-my-dashboard></app-my-dashboard>
</div>
<div class="pageContainer tabcontent" id="myWorkspace" 
[style.display] = "showNotificationList ? 'block' : 'none'"  *ngIf="showNotificationList">
     <app-notification-list></app-notification-list>
</div>